import { Controller } from 'stimulus';

/**
 * Re-visits the current page after a delay while the element stays mounted.
 * Disconnecting (a Turbo visit away, or the element being replaced) cancels it.
 *
 * @value delay - milliseconds before the re-visit (default 5000)
 */
export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } };

  connect() {
    this.timer = setTimeout(() => {
      window.Turbo.visit(window.location.href, { action: 'replace' });
    }, this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
